// A project, or its organization, being deleted (APS-406): its reads answer 410 erasing, and the
// shell shows one calm page in place of a page whose every panel would say so.
import { type Query, type QueryClient, useQueryClient } from '@tanstack/react-query'
import { useSyncExternalStore } from 'react'
import { type ApiError, erasing, erasingSubject } from '../api/client'

export type ErasingSubject = 'organization' | 'project'

/**
 * What a query of this project or organization (its key names it) answered is being deleted:
 * the organization when any says so, else the project; undefined when none answered erasing.
 */
export function erasingIn(
  qc: QueryClient,
  orgId: string,
  projectId: string,
): ErasingSubject | undefined {
  const ours = (q: Query) => q.queryKey.includes(projectId) || q.queryKey.includes(orgId)
  const subjects = qc
    .getQueryCache()
    .getAll()
    .filter((q) => q.state.status === 'error' && erasing(q.state.error) && ours(q))
    .map((q) => erasingSubject(q.state.error as ApiError))
  if (!subjects.length) return undefined
  return subjects.includes('organization') ? 'organization' : 'project'
}

/** erasingIn, kept up to date as queries settle. */
export function useErasing(orgId: string, projectId: string): ErasingSubject | undefined {
  const qc = useQueryClient()
  return useSyncExternalStore(
    (onChange) => qc.getQueryCache().subscribe(onChange),
    () => erasingIn(qc, orgId, projectId),
  )
}
